/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
/**
 * Chat message component.
 *
 * @styles
 *
 */
@Component({
    selector: 'nb-chat-message-custom',
    template: `
    <p class="sender" *ngIf="sender || date">{{ sender }} <time>{{ date  | date:'shortTime' }}</time></p>

    <div class="custom-message-container row">
        <div class="col-md-8 col-sm-10">
            <ng-content></ng-content>
        </div>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbChatMessageCustomComponent {

    /**
     * Message sender
     * @type {string}
     */
    @Input() sender: string;

    /**
     * List options
     * @type {any[]}
     */
    @Input() options: any[];

    /**
     * Message send date
     * @type {Date}
     */
    @Input() date: Date;

    /**
     * Message sent 
    */
    @Input() message: string;
    /**
     * Option clicked event 
    */
   @Output() optionClicked: EventEmitter<any> = new EventEmitter<any>();
   /**
    * To be called when the user clicks an option
    */
   chooseOption(value: string): void {
       this.optionClicked.emit({
            message: value
       });
   }

}
